import { Component } from '@angular/core';
import { Modal2Component } from '../modal-2/modal-2.component';
import { ModalService } from '../../../../../../components/modal-list/modal-list.service';
import { CloseConfirmationComponent } from './close-confirmation/close-confirmation.component';
import { I18nModule } from '@spartacus/core';

@Component({
  selector: 'app-modal-1',
  standalone: true,
  imports: [I18nModule],
  templateUrl: './modal-1.component.html',
  styleUrl: './modal-1.component.scss',
})
export class Modal1Component {
  constructor(private modalService: ModalService) {}

  openModal2() {
    this.modalService.create({
      id: 'modal-2',
      title: 'Modal 2',
      width: 500,
      component: Modal2Component,
    });
  }

  skipModal() {
    this.modalService.create({
      id: 'modal-1-close-confirmation',
      title: 'Modal 1 - Close Confirmation',
      width: 500,
      hasCloseButton: false,
      component: CloseConfirmationComponent,
    });
  }

  closeModal() {
    this.modalService.close();
  }
}
